<template>
    <main class="smaller-padding data-table">
        <div class="used-filter">
            <div class="tab-selector-wrapper">
                <app-tab-selector
                    v-model="tab"
                    :data-tabs="tabs"
                ></app-tab-selector>
            </div>
        </div>

        <v-data-table
            :headers="headers"
            :items="list"
            :total-items="30"
            :loading="loading"
            :pagination.sync="sync"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-promocional-code-table-item
                    :data-item="props.item"
                ></app-promocional-code-table-item>
            </template>
        </v-data-table>

        <v-pagination
            v-if="totalPages"
            v-model="sync.page"
            color="primary"
            :length="totalPages"
            :total-visible="7"
            @input="setPage"
        ></v-pagination>
    </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import paginatedTable from "@mixins/paginated-table";
import AppPromocionalCodeTableItem from "./components/PromocionalCodeTableItem";
import AppTabSelector from "@components/TabSelector";
import provider from "@mixins/provider";

export default {
    components: {
        AppTabSelector,
        AppPromocionalCodeTableItem,
    },

    data() {
        return {
            entity: "promocionalcode",
            tab: null,
        };
    },

    watch: {
        tab(tab) {
            const isNotUsed = tab === "NOTUSED";
            this.$store.commit("PROMOCIONALCODE_SET_FILTER", {
                key: "notUsed",
                value: isNotUsed,
            });
            EventBus.$emit("LOAD_PROMOCIONAL_CODE");
        },
    },

    mixins: [paginatedTable, provider],

    computed: {
        list() {
            return this.$store.state.promocionalcode.list;
        },

        filters() {
            return this.$store.state.promocionalcode.filters;
        },

        headers() {
            return this.tab === "NOTUSED"
                ? this.headersNotUsed
                : this.headersUsed;
        },

        headersUsed() {
            return [
                {
                    text: this.$t("message.coupons.message.code"),
                    value: "codigo",
                },
                {
                    text: this.$t("message.coupons.message.customerName"),
                    value: "nomeCliente",
                },
                {
                    text: this.$t("message.coupons.message.campaign"),
                    value: "nomeCampanha",
                },
                {
                    text: this.$t("message.coupons.message.spot"),
                    value: "nomeLocal",
                },
                {
                    text: this.$t("message.coupons.message.dateOfUse"),
                    value: "data_uso",
                },
            ];
        },

        headersNotUsed() {
            return [
                {
                    text: this.$t("message.coupons.message.code"),
                    value: "codigo",
                },
                {
                    text: this.$t("message.coupons.message.customerName"),
                    value: "nomeCliente",
                },
                {
                    text: this.$t("message.coupons.message.campaign"),
                    value: "nomeCampanha",
                },
                {
                    text: this.$t("message.coupons.message.spot"),
                    value: "nomeLocal",
                },
                {
                    text: this.$t("message.coupons.message.generationDate"),
                    value: "data",
                },
            ];
        },

        tabs() {
            return [
                {
                    label: this.$t("message.coupons.message.used"),
                    value: "USED",
                },

                {
                    label: this.$t("message.coupons.message.unused"),
                    value: "NOTUSED",
                },
            ];
        },
    },

    mounted() {
        this.$store.state.promocionalcode.list = [];
        this.$store.commit("PROMOCIONALCODE_SET_FILTER", {
            key: "search",
            value: "",
        });
        EventBus.$on("LOAD_PROMOCIONAL_CODE", this.load);
    },

    beforeDestroy() {
        EventBus.$off("LOAD_PROMOCIONAL_CODE", this.load);
    },
};
</script>

<style scoped>
.used-filter {
    width: 400px;
    display: block;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
}
</style>
